<template>
  <header class="py-4 px-4 border-2 border-dashed rounded-lg">
    <nav id="nav">
      <div class="flex items-center justify-between">
        <div data-name="logo-container">
          <a href="#">
            <svg
              width="163"
              height="24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.6 18.1a3 3 0 002.8-1.5V18h3.1v-6.5c0-2-1.7-3.3-4.2-3.3-2.7 0-4.3 1.3-4.4 3.2h2.8c0-.5.6-.9 1.4-.9.9 0 1.3.4 1.3 1.1v.5l-2.2.2c-2.4.1-3.8 1.1-3.8 3 0 1.6 1.3 2.8 3.2 2.8zm-.2-3c0-.6.5-1 1.3-1l1.7-.2v.7c0 .8-.7 1.4-1.7 1.4-.8 0-1.3-.4-1.3-1zm9.4 2.9h3.3l1.5-6.4 1.6 6.4h3.4L54 8.4h-3l-1.3 6.8-1.5-6.8h-3l-1.4 6.8h-.1l-1.2-6.8h-3.2l2.5 9.6zm17.5.2c3 0 4.2-1.8 4.5-3.1V15H61c-.1.4-.7 1-1.7 1-1.1 0-1.8-.8-1.8-2h6.4v-1c0-2.9-1.9-4.8-4.7-4.8-3 0-4.8 2-4.8 5 0 3.1 1.8 5 4.9 5zm0-7.8c.8 0 1.5.6 1.6 1.7h-3.4c.2-1 .8-1.7 1.7-1.7zm10 7.8c2.6 0 4.4-1.3 4.4-3.2 0-1.5-.9-2.3-2.9-2.7l-1.7-.3c-.9-.2-1.2-.4-1.2-.8 0-.6.5-.9 1.3-.9.9 0 1.3.5 1.4 1v.1h2.9c0-1.8-1.5-3.2-4.3-3.2-2.6 0-4.3 1.2-4.3 3.1 0 1.5 1 2.5 2.9 2.8l1.7.4c.8.1 1.1.4 1.1.8 0 .5-.5.8-1.3.8-1 0-1.4-.4-1.5-1V15h-3c.1 2 1.7 3.2 4.5 3.2zm10.1 0c3 0 5-1.8 5-5 0-3.1-2-5-5-5s-4.9 1.9-4.9 5c0 3.2 2 5 5 5zm0-2.4c-1 0-1.7-.9-1.7-2.6 0-1.7.7-2.6 1.7-2.6 1.1 0 1.8 1 1.8 2.6 0 1.7-.7 2.6-1.8 2.6zm6.1 2.2h3.2v-5.7c0-1 .5-1.5 1.3-1.5.9 0 1.4.5 1.4 1.5V18h3v-5.7c0-1 .5-1.5 1.3-1.5 1 0 1.4.5 1.4 1.5V18h3v-6.5c0-2-1.2-3.3-3-3.3-1.5 0-2.6.8-3 2-.3-1.2-1.3-2-2.7-2-1.3 0-2.3.8-2.7 2V8.4h-3.2V18zm20.7.2c3 0 4.3-1.8 4.6-3.1V15H108c-.2.4-.7 1-1.7 1-1.1 0-1.8-.8-1.9-2h6.5v-1c0-2.9-1.9-4.8-4.8-4.8s-4.7 2-4.7 5c0 3.1 1.8 5 4.8 5zm0-7.8c1 0 1.6.6 1.7 1.7h-3.4c.1-1 .8-1.7 1.7-1.7z"
                fill="#0A2540"
              />
              <path
                d="M116.3 18.2c2.6 0 4.4-1.3 4.4-3.2 0-1.5-.9-2.3-3-2.7l-1.6-.3c-1-.2-1.2-.4-1.2-.8 0-.6.5-.9 1.3-.9s1.3.5 1.4 1v.1h2.8c0-1.8-1.5-3.2-4.2-3.2s-4.3 1.2-4.3 3.1c0 1.5 1 2.5 2.9 2.8l1.6.4c.9.1 1.2.4 1.2.8 0 .5-.5.8-1.3.8-1 0-1.4-.4-1.6-1V15h-3c.2 2 1.7 3.2 4.6 3.2zm8.4 0a3 3 0 002.7-1.6V18h3.2v-6.5c0-2-1.7-3.3-4.3-3.3-2.6 0-4.2 1.3-4.4 3.2h2.8c.1-.5.6-.9 1.5-.9.8 0 1.3.4 1.3 1.1v.5l-2.2.2c-2.5.1-3.9 1.1-3.9 3 0 1.6 1.4 2.8 3.3 2.8zm-.2-3.2c0-.5.4-.9 1.3-1h1.7v.6c0 .8-.7 1.4-1.7 1.4-.8 0-1.3-.4-1.3-1zm10.8 3.2c1.5 0 2.5-.7 3-1.9V18h3.1V8.4h-3V14c0 1-.7 1.8-1.7 1.8s-1.5-.7-1.5-1.8V8.4H132v6.2c0 2.3 1.2 3.6 3.3 3.6zm12.2 0c2.8 0 4.4-1.7 4.5-3.9h-2.8c-.2 1-.7 1.5-1.7 1.5s-1.7-.9-1.7-2.6c0-1.7.7-2.6 1.7-2.6s1.5.6 1.6 1.5h3-.1c0-2.3-1.8-3.9-4.5-3.9-3 0-4.9 2-4.9 5 0 3.1 1.9 5 5 5zm10.2 0c3 0 4.3-1.8 4.6-3.1V15h-2.8c-.2.4-.7 1-1.7 1-1.1 0-1.8-.8-1.9-2h6.5v-1c0-2.9-1.9-4.8-4.8-4.8s-4.7 2-4.7 5c0 3.1 1.8 5 4.8 5zm0-7.8c1 0 1.6.6 1.7 1.7H156c.1-1 .8-1.7 1.7-1.7z"
                fill="#2953E6"
              />
              <g clip-path="url(#clip0)">
                <path
                  d="M24 12a12 12 0 01-24 .7v-.2l.2-1c.5-2 2.2-3.5 4.3-3.6H7v1.6H5.3A3.6 3.6 0 001.8 14 10.4 10.4 0 0012 22.3a10.4 10.4 0 10-1.4-20.6c-.7.4-1.2 1.2-1.2 2v8.4c0 1.2 1.1 2.2 2.4 2.2 1.3 0 2.4-1 2.4-2.4 0-1.3-1-2.3-2.3-2.4H8.6V7.8h3.1a4 4 0 014 4 4 4 0 01-4 4.1c-1.2 0-2.2-.5-3-1.3l-.3-.4a4 4 0 01-.8-2.2V3 3a3.7 3.7 0 013.7-3H12a12 12 0 0112 12z"
                  fill="#0A2540"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </div>
        <!--
            active classes: 'text-white border-b-2 border-white' a
        -->
        <div data-name="middle" class="flex space-x-8 text-sm">
          <a class="text-indigo-800 border-b-2 border-indigo-700" href="#"
            >Home</a
          >
          <a
            class="text-gray-900 transition duration-200 hover:text-indigo-400"
            href="#"
            >Link One</a
          >
          <a
            class="text-gray-900 transition duration-200 hover:text-indigo-400"
            href="#"
            >Link Two</a
          >
          <a
            class="text-gray-900 transition duration-200 hover:text-indigo-400"
            href="#"
            >Link Three</a
          >
        </div>
        <div data-name="sign-in">
          <button
            class="text-sm px-6 py-2 rounded-full flex items-center space-x-2 transition duration-500 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:shadow-outline"
          >
            <p>Sign in</p>

            <svg
              class="w-3 h-3"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="currentColor"
                fill-rule="evenodd"
              >
                <g id="icon-shape">
                  <polygon
                    id="Combined-Shape-Copy"
                    points="16.1715729 9 10.1005051 2.92893219 11.5147186 1.51471863 20 10 19.2928932 10.7071068 11.5147186 18.4852814 10.1005051 17.0710678 16.1715729 11 -5.68434189e-14 11 -5.68434189e-14 9"
                  ></polygon>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: "NavOne"
};
</script>
